var content = require("!!../../../cvat-ui/node_modules/css-loader/dist/cjs.js??ref--5-1!../../../cvat-ui/node_modules/postcss-loader/src/index.js!../../../cvat-ui/node_modules/sass-loader/dist/cjs.js!./canvas.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../cvat-ui/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
